import React from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddResponsibilityForm from '../../../components/forms/responsibility/AddResponsibilityForm';
import PageHeader from '../../../components/common/PageHeader';

export default function AddResponsibility() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'担当規模登録'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/responsiblities'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddResponsibilityForm />
            </Box>
        </>   
    ) 
}
